import { render, staticRenderFns } from "./AddCosting.vue?vue&type=template&id=14fb2fb1&scoped=true"
import script from "./AddCosting.vue?vue&type=script&lang=js"
export * from "./AddCosting.vue?vue&type=script&lang=js"
import style0 from "./AddCosting.vue?vue&type=style&index=0&id=14fb2fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb2fb1",
  null
  
)

export default component.exports